import React from 'react';
import PropTypes from 'prop-types';

import {Col, ControlLabel, FormControl, FormGroup, Grid, Row} from "react-bootstrap";

import Card from "components/Card/Card.jsx";


class ProductReferenceForm extends React.Component {

    render() {
        return (
            <Card
                content={
                    <Grid fluid>
                        <Row>
                            <Col xs={12} sm={6} md={4}>
                                <FormGroup>
                                    <ControlLabel>DDD</ControlLabel>
                                    <FormControl
                                        placeholder="DDD"
                                        type="text"
                                        onChange={(val) => this.props.setValue(val.target.value, 'DDD')}
                                        value={this.props.state.DDD}
                                    />
                                </FormGroup>
                            </Col>
                            <Col xs={12} sm={6} md={4}>
                                <FormGroup>
                                    <ControlLabel>Assurance</ControlLabel>
                                    <FormControl
                                        placeholder="Assurance"
                                        type="text"
                                        onChange={(val) => this.props.setValue(val.target.value, 'assurance')}
                                        value={this.props.state.assurance}
                                    />
                                </FormGroup>
                            </Col>
                            <Col xs={12} sm={6} md={4}>
                                <FormGroup>
                                    <ControlLabel>Excipient à éffets notoires</ControlLabel>
                                    <FormControl
                                        placeholder="Excipient à éffets notoires"
                                        type="text"
                                        onChange={(val) => this.props.setValue(val.target.value, 'excipientEffetsNotoires')}
                                        value={this.props.state.excipientEffetsNotoires}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <FormGroup>
                                    <ControlLabel>Propriétés</ControlLabel>
                                    <FormControl
                                        placeholder="Propriétés *"
                                        componentClass="textarea"
                                        onChange={(val) => this.props.setValue(val.target.value, 'proprietes')}
                                        value={this.props.state.proprietes}
                                        required
                                    />
                                </FormGroup>
                            </Col>
                            <Col xs={12}>
                                <FormGroup>
                                    <ControlLabel>Indications</ControlLabel>
                                    <FormControl
                                        placeholder="Indications *"
                                        componentClass="textarea"
                                        onChange={(val) => this.props.setValue(val.target.value, 'indications')}
                                        value={this.props.state.indications}
                                        required
                                    />
                                </FormGroup>
                            </Col>
                            <Col xs={12}>
                                <FormGroup>
                                    <ControlLabel>Posologie</ControlLabel>
                                    <FormControl
                                        placeholder="Posologie *"
                                        componentClass="textarea"
                                        onChange={(val) => this.props.setValue(val.target.value, 'posologie')}
                                        value={this.props.state.posologie}
                                        required
                                    />
                                </FormGroup>
                            </Col>
                            <Col xs={12}>
                                <FormGroup>
                                    <ControlLabel>Contre Indications</ControlLabel>
                                    <FormControl
                                        placeholder="Contre Indications *"
                                        componentClass="textarea"
                                        onChange={(val) => this.props.setValue(val.target.value, 'contreIndications')}
                                        value={this.props.state.contreIndications}
                                        required
                                    />
                                </FormGroup>
                            </Col>
                            <Col xs={12}>
                                <FormGroup>
                                    <ControlLabel>Effets indésirables</ControlLabel>
                                    <FormControl
                                        placeholder="Effets indésirables *"
                                        componentClass="textarea"
                                        onChange={(val) => this.props.setValue(val.target.value, 'effetsIndesirables')}
                                        value={this.props.state.effetsIndesirables}
                                        required
                                    />
                                </FormGroup>
                            </Col>
                            <Col xs={12}>
                                <FormGroup>
                                    <ControlLabel>{'Précautions d\'emploi'}</ControlLabel>
                                    <FormControl
                                        placeholder="Précautions d'emploi *"
                                        componentClass="textarea"
                                        onChange={(val) => this.props.setValue(val.target.value, 'precautionsEmploi')}
                                        value={this.props.state.precautionsEmploi}
                                        required
                                    />
                                </FormGroup>
                            </Col>
                            <Col xs={12}>
                                <FormGroup>
                                    <ControlLabel>Interactions médicamenteuses</ControlLabel>
                                    <FormControl
                                        placeholder="Interactions médicamenteuses *"
                                        componentClass="textarea"
                                        onChange={(val) => this.props.setValue(val.target.value, 'interactionsMedicamenteuses')}
                                        value={this.props.state.interactionsMedicamenteuses}
                                        required
                                    />
                                </FormGroup>
                            </Col>
                            <Col xs={12} sm={6} md={4}>
                                <FormGroup>
                                    <ControlLabel>No AMM ou enregistrement</ControlLabel>
                                    <FormControl
                                        placeholder="No AMM ou enregistrement"
                                        type="text"
                                        onChange={(val) => this.props.setValue(val.target.value, 'nomAMMouEnregistrement')}
                                        value={this.props.state.nomAMMouEnregistrement}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                    </Grid>
                }
            />
        );
    }

}

ProductReferenceForm.propTypes = {
    state: PropTypes.object,

    setValue: PropTypes.func
};

export default ProductReferenceForm;